import React from "react";

const fallbackIcons = [
  "checkCircle",
  "bolt",
  "refresh",
  "chart",
  "shield",
  "download",
  "mobile",
  "globe"
];

const aliases = {
  "fa-check": "checkCircle",
  "fa-bolt": "bolt",
  "fa-refresh": "refresh",
  "fa-line-chart": "chart",
  "fa-shield": "shield",
  "fa-download": "download",
  "fa-mobile": "mobile",
  "fa-globe": "globe",
  "fa-qrcode": "qrcode",
  "fa-paint-brush": "palette",
  "fa-file-pdf-o": "pdf",
  "fa-cloud": "cloudLinks",
  "fa-map-marker": "location",
  "fa-credit-card": "payment",
  "fa-link": "link",
  "fa-check-square-o": "ninecheck",
  "fa-address-card-o": "ninecard",
  "fa-cutlery": "menu"
};

export const OutlineIcon = ({ name, size = 20, className = "" }) => {
  const iconName = aliases[name] || name || "sparkles";
  let artwork;

  switch (iconName) {
    case "check":
      artwork = <path d="m5 12 4 4L19 6" />;
      break;
    case "checkCircle":
      artwork = (
        <>
          <circle cx="12" cy="12" r="9" />
          <path d="m8 12 2.6 2.6L16.5 9" />
        </>
      );
      break;
    case "search":
      artwork = (
        <>
          <circle cx="10.5" cy="10.5" r="6.5" />
          <path d="m15.5 15.5 5 5" />
        </>
      );
      break;
    case "infinity":
      artwork = (
        <path d="M7.2 8.2C4.9 8.2 3 9.9 3 12s1.9 3.8 4.2 3.8c3.7 0 5.9-7.6 9.6-7.6 2.3 0 4.2 1.7 4.2 3.8s-1.9 3.8-4.2 3.8c-3.7 0-5.9-7.6-9.6-7.6Z" />
      );
      break;
    case "qrcode":
    case "static":
      artwork = (
        <>
          <rect x="3.5" y="3.5" width="6" height="6" rx="1" />
          <rect x="14.5" y="3.5" width="6" height="6" rx="1" />
          <rect x="3.5" y="14.5" width="6" height="6" rx="1" />
          <path d="M14.5 14.5h2.2v2.2h-2.2zM18.3 14.5h2.2v6h-2.2zM14.5 18.3h2.2v2.2h-2.2z" />
        </>
      );
      break;
    case "clock":
      artwork = (
        <>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3.5 2" />
        </>
      );
      break;
    case "briefcase":
      artwork = (
        <>
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M3 12h18M10 12v2h4v-2" />
        </>
      );
      break;
    case "dynamic":
    case "refresh":
      artwork = (
        <>
          <path d="M20 7v5h-5M4 17v-5h5" />
          <path d="M6.1 8.2A7 7 0 0 1 18.7 7L20 12M4 12l1.3 5A7 7 0 0 0 17.9 15.8" />
        </>
      );
      break;
    case "pdf":
    case "file":
      artwork = (
        <>
          <path d="M6 3h8l4 4v14H6zM14 3v5h4" />
          <path d="M9 12h6M9 15h6M9 18h4" />
        </>
      );
      break;
    case "cloudLinks":
      artwork = (
        <>
          <path d="M7.2 18.5H18a3.5 3.5 0 0 0 .4-7A6 6 0 0 0 6.9 9.8a4.4 4.4 0 0 0 .3 8.7Z" />
          <path d="M9 13.5h6M9 16h4" />
        </>
      );
      break;
    case "location":
      artwork = (
        <>
          <path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z" />
          <circle cx="12" cy="9" r="2.4" />
        </>
      );
      break;
    case "payment":
      artwork = (
        <>
          <rect x="2.8" y="5" width="18.4" height="14" rx="2.3" />
          <path d="M3 9h18M7 15h4M16.5 13.5v3M15 15h3" />
        </>
      );
      break;
    case "link":
      artwork = (
        <>
          <path d="m9.5 14.5 5-5" />
          <path d="M7.3 16.7 5.6 18.4a2.8 2.8 0 0 1-4-4l3.2-3.2a2.8 2.8 0 0 1 4 0M16.7 7.3l1.7-1.7a2.8 2.8 0 0 1 4 4l-3.2 3.2a2.8 2.8 0 0 1-4 0" />
        </>
      );
      break;
    case "ninecheck":
      artwork = (
        <>
          <rect x="3.5" y="3.5" width="7" height="7" rx="1" />
          <path d="M6 6h2v2H6zM4 15h3v3H4zM9 14h2v2H9zM9 18h2v2H9z" />
          <circle cx="17" cy="16.5" r="4.5" />
          <path d="m15 16.5 1.4 1.4 2.7-3" />
        </>
      );
      break;
    case "ninecard":
      artwork = (
        <>
          <rect x="3" y="4" width="18" height="16" rx="2.5" />
          <circle cx="8" cy="10" r="2.2" />
          <path d="M5.3 16c.5-1.8 1.4-2.8 2.7-2.8s2.2 1 2.7 2.8M13.5 9h4.5M13.5 13h4.5M13.5 16h3" />
        </>
      );
      break;
    case "menu":
      artwork = (
        <>
          <path d="M8 4v6a2 2 0 0 1-4 0V4M6 4v16M14 4v16M14 4c4 1.2 5.2 6.2 0 8" />
        </>
      );
      break;
    case "globe":
      artwork = (
        <>
          <circle cx="12" cy="12" r="9" />
          <path d="M3.5 12h17M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21c-2.2-2.4-3.3-5.4-3.3-9S9.8 5.4 12 3Z" />
        </>
      );
      break;
    case "wifi":
      artwork = (
        <>
          <path d="M4 9a12 12 0 0 1 16 0M7 12.5a7.5 7.5 0 0 1 10 0M10 16a3 3 0 0 1 4 0" />
          <circle cx="12" cy="19" r=".8" fill="currentColor" stroke="none" />
        </>
      );
      break;
    case "user":
      artwork = (
        <>
          <circle cx="12" cy="8" r="4" />
          <path d="M4.5 21c.6-4.2 3.1-6.5 7.5-6.5s6.9 2.3 7.5 6.5" />
        </>
      );
      break;
    case "text":
      artwork = <path d="M4 6h16M8 6v14M16 6v14M5 20h6M13 20h6" />;
      break;
    case "mail":
      artwork = (
        <>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m4 7 8 6 8-6" />
        </>
      );
      break;
    case "message":
      artwork = (
        <path d="M5 4h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-8l-5.5 4v-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" />
      );
      break;
    case "image":
      artwork = (
        <>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <circle cx="8.5" cy="9" r="2" />
          <path d="m4 18 5.2-5 3.5 3 2.4-2.2L20 18" />
        </>
      );
      break;
    case "chart":
      artwork = (
        <>
          <path d="M4 20V10M10 20V4M16 20v-7M22 20V7" />
          <path d="M3 20h20" />
        </>
      );
      break;
    case "palette":
      artwork = (
        <>
          <path d="M12 3a9 9 0 0 0 0 18h1.2a1.8 1.8 0 0 0 1.5-2.8 1.8 1.8 0 0 1 1.5-2.8H18a3 3 0 0 0 3-3A9 9 0 0 0 12 3Z" />
          <circle cx="7.5" cy="10" r=".8" fill="currentColor" stroke="none" />
          <circle cx="10" cy="6.8" r=".8" fill="currentColor" stroke="none" />
          <circle cx="14.2" cy="6.5" r=".8" fill="currentColor" stroke="none" />
          <circle cx="17" cy="9.5" r=".8" fill="currentColor" stroke="none" />
        </>
      );
      break;
    case "download":
      artwork = (
        <>
          <path d="M12 3v12M7.5 10.5 12 15l4.5-4.5" />
          <path d="M4 20h16" />
        </>
      );
      break;
    case "shield":
      artwork = (
        <>
          <path d="M12 3 4.5 6v5.5c0 4.6 2.8 7.8 7.5 9.5 4.7-1.7 7.5-4.9 7.5-9.5V6Z" />
          <path d="m8.5 12 2.3 2.3 4.7-5" />
        </>
      );
      break;
    case "mobile":
      artwork = (
        <>
          <rect x="6.5" y="2.5" width="11" height="19" rx="2" />
          <path d="M10 5h4M10.5 18.5h3" />
        </>
      );
      break;
    case "restaurant":
      artwork = (
        <>
          <path d="M6 3v8M3.5 3v5a2.5 2.5 0 0 0 5 0V3M6 11v10M14 3v18M14 3c4 1 5.5 6.3 0 9" />
        </>
      );
      break;
    case "megaphone":
      artwork = (
        <>
          <path d="M4 10v4h4l9 4V6L8 10Z" />
          <path d="m8 14 1 6h3l-1-5M20 9v6" />
        </>
      );
      break;
    case "certificate":
      artwork = (
        <>
          <rect x="4" y="3" width="16" height="14" rx="2" />
          <circle cx="12" cy="10" r="3" />
          <path d="m10 16-1 5 3-1.8L15 21l-1-5" />
        </>
      );
      break;
    case "poster":
      artwork = (
        <>
          <rect x="4" y="3" width="16" height="18" rx="1.5" />
          <path d="M8 8h8M8 12h8M8 16h5" />
        </>
      );
      break;
    case "bolt":
      artwork = <path d="M13.5 2 5 13h6l-.5 9L19 10h-6Z" />;
      break;
    case "idea":
      artwork = (
        <>
          <path d="M9 18h6M10 21h4" />
          <path d="M12 3a6 6 0 0 0-3.5 10.9c.8.6 1.5 1.6 1.5 2.6V17h4v-.5c0-1 .7-2 1.5-2.6A6 6 0 0 0 12 3Z" />
        </>
      );
      break;
    case "music":
      artwork = (
        <>
          <path d="M9 18V5l10-2v13" />
          <circle cx="6" cy="18" r="3" />
          <circle cx="16" cy="16" r="3" />
        </>
      );
      break;
    case "send":
      artwork = (
        <>
          <path d="m22 2-7 20-4-9-9-4Z" />
          <path d="M22 2 11 13" />
        </>
      );
      break;
    default:
      artwork = (
        <path d="m12 3 1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7ZM19 16l.7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7Z" />
      );
  }

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {artwork}
    </svg>
  );
};

export const RedesignIcon = ({ name, index = 0 }) => (
  <span className="rd-icon" aria-hidden="true">
    <OutlineIcon name={name || fallbackIcons[index % fallbackIcons.length]} />
  </span>
);

export const CheckMark = () => (
  <span className="rd-check" aria-hidden="true">
    <OutlineIcon name="check" size={12} />
  </span>
);
